import { Breakpoints, styled } from '@vw-marketing/us-components';

export const StyledSalesMlp: any = styled.div`
  ${({ theme }) => {
    return `
      display: flex;
      flex-direction: column;
      align-items: center;
      height: 100%;
      justify-content: center;
      width: 100vw;

      @media (min-width: ${Breakpoints.b1280}px) {
        padding: ${theme.size.dynamic0150} 53px;
        width: 100%;
      }

      @media (min-width: ${Breakpoints.b1600}px) {
        padding: ${theme.size.dynamic0150} 67px;
      }
    `;
  }}
`;

export const StyledSalesEventTitleWrapper: any = styled.div`
  ${({ theme }) => {
    return `
      display: flex;
      justify-content: center;
      padding-bottom: ${theme.size.dynamic0100};
      width: 100%;
    `;
  }}
`;
